var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business-Partners-v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "100_BPv3",
    transform: "translate(-706.000000, -695.000000)",
    fill: "#04246A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components-/-02-Icon-/-16-/-Icon-Graphic",
    transform: "translate(706.000000, 695.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,15 L9,16 L6,16 L6,15 L9,15 Z M3.9986279,13 L4,14.9950619 L5,14.9950619 L5,15.9969268 L3,15.9969268 L3,13.0008628 L3.9986279,13 Z M12,13.0008628 L12,15.9969268 L10,15.9969268 L10,14.9950619 L11,14.9950619 L11.0013721,13 L12,13.0008628 Z M9,0 L9,2 L8,2 L8,1 L1,1 L1,13.0028736 L2,13.0028736 L2,14.0028736 L0,14.0028736 L0,0 L9,0 Z M12,10 L12,12 L11,12 L11,10 L12,10 Z M4,10 L4,12 L3,12 L3,10 L4,10 Z M12,7 L12,9 L11,9 L11,7 L12,7 Z M4,7 L4,9 L3,9 L3,7 L4,7 Z M5,3 L5,4.00186491 L4,4.00186491 L3.9986279,5.99692683 L3,5.99606399 L3,3 L5,3 Z M12,3 L12,5.99606399 L11.0013721,5.99692683 L11,4.00186491 L10,4.00186491 L10,3 L12,3 Z M9,3 L9,4 L6,4 L6,3 L9,3 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.024495bc0a337e68eb2bb669140df4df.svg";
export { ForwardRef as ReactComponent };